import type { FC, SVGProps } from 'react';

const GoalIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9998 8V5L18.9998 2L19.9998 4L21.9998 5L18.9998 8H15.9998ZM15.9998 8L11.9998 11.9999M21.9999 12C21.9999 17.5228 17.5227 22 11.9999 22C6.47703 22 1.99988 17.5228 1.99988 12C1.99988 6.47715 6.47703 2 11.9999 2M16.9999 12C16.9999 14.7614 14.7613 17 11.9999 17C9.23845 17 6.99988 14.7614 6.99988 12C6.99988 9.23858 9.23845 7 11.9999 7"
      stroke="#667180"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GoalIcon;
